// extracted by mini-css-extract-plugin
module.exports = {"event-price-pills":"EventPricePills_event-price-pills__cB9rl"};